"use client";

import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { ArrowRight, PhoneCall, CircleCheck as CheckCircle2, ShieldCheck } from 'lucide-react';
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function CallToAction() {
  const prefersReducedMotion = useReducedMotion();
  return <section id="calltoaction" data-nav="light" className="relative overflow-hidden bg-background py-16 md:py-24">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div initial={prefersReducedMotion ? {
        opacity: 1
      } : {
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.3
      }} transition={{
        duration: 0.5,
        ease: "easeOut"
      }} className="relative overflow-hidden rounded-2xl bg-primary text-primary-foreground p-8 sm:p-12 lg:p-16 shadow-xl">
          {/* Subtle industrial background pattern */}
          <div className="pointer-events-none absolute inset-0 opacity-10">
            <svg className="h-full w-full" viewBox="0 0 100 100" preserveAspectRatio="none" fill="none" stroke="currentColor">
              <pattern id="cta-grid" width="8" height="8" patternUnits="userSpaceOnUse">
                <path d="M 8 0 L 0 0 0 8" fill="none" stroke="currentColor" strokeWidth="0.5" />
              </pattern>
              <rect width="100%" height="100%" fill="url(#cta-grid)" />
            </svg>
          </div>

          <div className="relative z-10 mx-auto max-w-3xl text-center">
            <div className="inline-flex items-center gap-2 rounded-full bg-secondary/20 px-3.5 py-1 text-xs font-semibold uppercase tracking-wider text-secondary-foreground">
              <ShieldCheck className="size-4" />
              <span>Engenharia e Pulverização Industrial</span>
            </div>

            <h2 className="mt-6 text-2xl font-bold tracking-tight text-primary-foreground sm:text-3xl lg:text-4xl font-default">
              Otimize a eficiência da sua linha de pulverização
            </h2>

            <p className="mt-4 text-base text-primary-foreground/90 sm:text-lg">
              Fale diretamente com os nossos engenheiros técnicos para analisar as
              suas necessidades e receber uma solução dimensionada para o seu processo.
            </p>

            <div className="mt-8 flex flex-col items-center justify-center gap-4 sm:flex-row">
              <Button asChild size="lg" className="w-full sm:w-auto bg-secondary text-secondary-foreground shadow-md hover:bg-secondary/90 text-base font-semibold px-8 py-6 rounded-lg transition-[background-color,box-shadow]">
                <Link to="/ContactsPage" className="inline-flex items-center justify-center gap-2">
                  <span>Solicite um orçamento</span>
                  <ArrowRight className="size-5" />
                </Link>
              </Button>

              <Button asChild variant="outline" size="lg" className="w-full sm:w-auto border-primary-foreground/30 bg-primary/40 text-primary-foreground hover:bg-primary-foreground/10 px-6 py-6 rounded-lg transition-[background-color,border-color]">
                <Link to="/ContactsPage" className="inline-flex items-center justify-center gap-2">
                  <PhoneCall className="size-4" />
                  <span>Consulte-nos</span>
                </Link>
              </Button>
            </div>

            <div className="mt-10 pt-8 border-t border-primary-foreground/15 grid grid-cols-1 gap-4 sm:grid-cols-3 text-left text-xs sm:text-sm text-primary-foreground/80">
              <div className="flex items-center gap-2.5">
                <CheckCircle2 className="size-4 shrink-0 text-secondary-foreground" />
                <span>Representante oficial Spraying Systems Co.</span>
              </div>
              <div className="flex items-center gap-2.5">
                <CheckCircle2 className="size-4 shrink-0 text-secondary-foreground" />
                <span>Apoio técnico e diagnóstico no terreno</span>
              </div>
              <div className="flex items-center gap-2.5">
                <CheckCircle2 className="size-4 shrink-0 text-secondary-foreground" />
                <span>Soluções personalizadas à medida</span>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}